import type { Locale } from '@/i18n/i18n';

const URL_PREFIX_LOCALES = ['en', 'uk'] as const satisfies readonly Locale[];

export function localeFromPath(pathname: string): Locale | null {
  const seg = pathname.split('/')[1];
  if (URL_PREFIX_LOCALES.includes(seg as (typeof URL_PREFIX_LOCALES)[number])) {
    return seg as Locale;
  }
  return null;
}

export function stripLocale(pathname: string): string {
  const locale = localeFromPath(pathname);
  if (!locale) return pathname;
  const rest = pathname.slice(`/${locale}`.length);
  return rest || '/';
}

/** Build a localized public path, matching the language switcher's canonical URLs. */
export function localePath(path: string, locale: Locale): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const suffixIndex = normalizedPath.search(/[?#]/);
  const suffix = suffixIndex < 0 ? '' : normalizedPath.slice(suffixIndex);
  const pathname = stripLocale(
    suffixIndex < 0 ? normalizedPath : normalizedPath.slice(0, suffixIndex)
  );
  const legalPath =
    pathname === '/privacy' || pathname === '/polityka-prywatnosci'
      ? locale === 'pl'
        ? '/polityka-prywatnosci'
        : '/privacy'
      : pathname === '/terms' || pathname === '/regulamin'
        ? locale === 'pl'
          ? '/regulamin'
          : '/terms'
        : pathname;
  if (locale === 'pl') return legalPath + suffix;
  return `/${locale}${legalPath === '/' ? '' : legalPath}${suffix}`;
}

/** These canonical documents are served by the frontend through the www proxy. */
export function isProxyOwnedLegalPath(path: string): boolean {
  const pathname = path.split(/[?#]/, 1)[0];
  return pathname === '/polityka-prywatnosci' || pathname === '/regulamin';
}
